
import Vue from 'vue';
import { ClientConstants } from './client.constants';
import MainCard from './components/MainCard.vue';
import PageHeader from './components/PageHeader.vue';
import PageFooter from './components/PageFooter.vue';

export default Vue.extend({
    components: {
        MainCard,
        PageHeader,
        PageFooter
    },
    mounted() {
        let glanceScript = document.createElement('script');
        glanceScript.type = 'text/javascript';
        let glanceUrl = '';
        switch (process.env.NODE_ENV) {
            case 'development': {
                glanceUrl = ClientConstants.GLANCE_URL_DEV;
                break;
            }
            case 'test': {
                glanceUrl = ClientConstants.GLANCE_URL_QA;
                break;
            }
            case 'production': {
                glanceUrl = ClientConstants.GLANCE_URL_PROD;
                break;
            }
            default: {
                glanceUrl = ClientConstants.GLANCE_URL_DEV;
                break;
            }
        }
        glanceScript.src = glanceUrl;
        document.head.appendChild(glanceScript);
    },
});
